import React, { useState, useRef } from 'react' // Importamos o useRef
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
  Box
} from '@material-ui/core'
import { Paperclip } from 'lucide-react' // Ícone de clipe igual ao da imagem
import { toast } from 'react-toastify'
import { InputFieldText } from '../../components/InputFieldText'
import api from '../../services/api'
import toastError from '../../errors/toastError'
import { useStyles } from './style'
import { ButtonSecondary } from '../ButtonSecondary'
import { ButtonPrimary } from '../ButtonPrimary'
import { AttachmentInput } from '../AttachmentInput'

const NotificationSoundModal = ({ open, onClose, onSave }) => {
  const classes = useStyles()
  const fileInputRef = useRef(null) // Referência para o input escondido

  const [uploading, setUploading] = useState(false)
  const [uploadName, setUploadName] = useState('')
  const [uploadFile, setUploadFile] = useState(null)
  const [audioPath, setAudioPath] = useState(null)

  const handleClose = () => {
    setUploadName('')
    setUploadFile(null)
    if (audioPath && audioPath.startsWith('blob:')) {
      URL.revokeObjectURL(audioPath) // Liberação de memória
    }
    setAudioPath(null)
    onClose()
  }

  // Dispara o clique no input real quando o botão estilizado é clicado
  const handleAttachClick = () => {
    fileInputRef.current.click()
  }

  const handleUpload = async () => {
    if (!uploadFile) {
      toast.error('Selecione um arquivo de áudio para enviar.')
      return
    }

    const formData = new FormData()
    formData.append('file', uploadFile)
    if (uploadName.trim()) {
      formData.append('name', uploadName.trim())
    }

    setUploading(true)
    try {
      await api.post('/notification-sounds', formData)
      toast.success('Áudio enviado com sucesso.')
      onSave()
      handleClose()
    } catch (error) {
      toastError(error)
    } finally {
      setUploading(false)
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle className={classes.dialogTitle}>
        Novo Som de Notificação
      </DialogTitle>
      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <InputFieldText
              fullWidth
              label="Nome do áudio"
              value={uploadName}
              onChange={e => setUploadName(e.target.value)}
              placeholder="Ex.: Notificação Suave"
            />
          </Grid>

          <Grid item xs={12}>
            <Box display="flex" justifyContent="center">
              {/* Integração direta com controle de tamanho e preview nativo de áudio */}
              <AttachmentInput
                type="audio"
                mediaPath={audioPath}
                mediaName={uploadFile?.name || null}
                displayName="som de notificação"
                size="large" // Deixa o botão confortável no layout do modal pequeno
                onFileSelect={(file, url) => {
                  setUploadFile(file)
                  setAudioPath(url)
                }}
                onFileRemove={() => {
                  setUploadFile(null)
                  if (audioPath && audioPath.startsWith('blob:')) {
                    URL.revokeObjectURL(audioPath)
                  }
                  setAudioPath(null)
                }}
              />
            </Box>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <ButtonSecondary
          label="Cancelar"
          onClick={handleClose}
          disabled={uploading}
        />
        <ButtonPrimary
          onClick={handleUpload}
          disabled={uploading || !uploadFile}
          label={'Salvar'}
        />
      </DialogActions>
    </Dialog>
  )
}

export default NotificationSoundModal
